import * as React from 'react';
import { defaultPlaybackContext } from '../defaultSettings';
var context = React.createContext(defaultPlaybackContext);
export var PlaybackContextProvider = context.Provider;
export var PlaybackContextConsumer = context.Consumer;
//# sourceMappingURL=PlaybackContext.js.map